import { useRecoilValue } from "recoil";
import { insetState } from "../../recoil/inset";
import { HeaderTitle, HeaderWrapper } from "./style";
import { useHistory } from "react-router-dom";

export interface HeaderProps {
  show?: boolean;
  title: string;
  back?: () => void;
  buttonClick?: () => void;
  img?: string;
  imgSize?: string;
}

const Header = ({
  show,
  title,
  back,
  buttonClick,
  img,
  imgSize,
}: HeaderProps) => {
  const inset = useRecoilValue(insetState);
  const history = useHistory();

  return (
    <HeaderWrapper inset={inset} show={show || false} imgSize={imgSize}>
      <HeaderTitle show={show || false}>
        <img
          alt="back"
          src={`/image-web/Icon/Back${show ? "_white" : ""}.svg`}
          onClick={() => (back ? back() : history.goBack())}
        />
        <div className="name">{title}</div>
      </HeaderTitle>
      {img && (
        <div className="button" onClick={buttonClick}>
          <img src={img} alt="button" />
        </div>
      )}
    </HeaderWrapper>
  );
};

export default Header;
